module.exports = "<div id=\"wd-file-transfer-manager-pop-over\"></div>\n";